<template>
    <div :class="`product-style-one ${productStyleClass}`">
        <div class="card-thumbnail">
            <router-link :to="`/product/${productDate.id}`">
                <img :src="productDate.productImage" :alt="productDate.productName" @load="$emit('handleImageLoad')">
            </router-link>
        </div>
        <div class="product-share-wrapper">
            <div class="profile-share">
                <router-link v-for="(author, index) in productDate.authors"
                             :key="`screenshot-${index}`"
                             :to="`/product/${productDate.id}`"
                             class="avatar"
                             :data-tooltip="`Screenshot ${index + 1}`">
                    <img :src="author.image" :alt="`Screenshot ${index + 1}`">
                </router-link>
            </div>
            <div class="share-btn share-btn-activation dropdown">
                <button class="icon" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="feather-more-horizontal"/>
                </button>
                <div class="share-btn-setting dropdown-menu dropdown-menu-end">
                    <button type="button"
                            class="btn-setting-text share-text"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal">
                        Share
                    </button>
                </div>
            </div>
        </div>
        <router-link :to="`/product/${productDate.id}`">
            <span class="product-name">{{ productDate.productName }}</span>
        </router-link>
        <span class="latest-bid">{{ productDate.latestBid }}</span>
    </div>
</template>

<script>
    import Countdown from '@/components/product/Countdown';

    export default {
        name: 'ProductCard',
        components: {Countdown},
        props: {
            productDate: {},
            productStyleClass: {
                type: String
            },
            showPlaceBid: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            '$route': function (to, from) {
                this.closeModal()
            }
        },
        methods: {
            closeModal() {
                const modals = document.querySelectorAll('.modal-backdrop');

                if (modals.length) {
                    modals.forEach(item => {
                        item.remove();
                    })
                }
            }
        }
    }
</script>